const validations = {
  name: {
    required: true,
  },
};

export { validations };
